import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { CreateUserInvitationState } from "./types"

const initialState: CreateUserInvitationState = {
    isCreateModalOpen: false,
    isBulkModalOpen: false,
    onCreate: null,
}

const createUserInvitationSlice = createSlice({
    name: 'createUserInvitation',
    initialState,
    reducers: {
        openCreateModal: (state, action: PayloadAction<{ onCreate?: () => void }>) => {
            state.isCreateModalOpen = true
            state.onCreate = action.payload.onCreate ?? null
        },
        closeCreateModal: (state) => {
            state.isCreateModalOpen = false
            state.onCreate = null
        },
        openBulkModal: (state, action: PayloadAction<{ onCreate?: () => void }>) => {
            state.isBulkModalOpen = true
            state.onCreate = action.payload.onCreate ?? null
        },
        closeBulkModal: (state) => {
            state.isBulkModalOpen = false
            state.onCreate = null
        },
    }
})

export default createUserInvitationSlice.reducer
export const {
    openCreateModal,
    closeCreateModal,
    openBulkModal,
    closeBulkModal,
} = createUserInvitationSlice.actions
